'use client'
import Link from 'next/link'
import { useLocale } from 'next-intl'
import { getFeatureLink, getFeatureIndexLink } from '@/lib/feature-link-utils'
import type { ReactNode } from 'react'
import type { Locale } from '@/i18n/config'

export interface FeatureLinkProps {
  /** feature页面的slug，如果为空则链接到feature主页 */
  featureSlug?: string
  /** 子元素 */
  children: ReactNode
  /** 自定义类名 */
  className?: string
  /** 其他Link组件的props */
  [key: string]: any
}

/**
 * Feature页面链接组件
 * 自动根据当前语言生成正确的feature页面链接
 * 只有feature页面有国际化路由，其他页面不受影响
 */
export const FeatureLink = ({
  featureSlug,
  children,
  className,
  ...linkProps
}: FeatureLinkProps) => {
  const locale = useLocale()

  // 生成正确的feature链接
  const href = featureSlug
    ? getFeatureLink(featureSlug, locale as Locale)
    : getFeatureIndexLink(locale as Locale)

  return (
    <Link href={href} className={className} {...linkProps}>
      {children}
    </Link>
  )
}
